import "../../../styles/login.css";

const Home = () => {
  return (
    <>
      <h1>Logistic</h1>
    </>
  );
};

export default Home;
